import { useHistory } from "react-router-dom"
import { Container } from "src/components/container"
import { Image } from "src/components/Image"
import { Button } from "src/components/ui/button"
import { ChevronRight } from "src/icons"
import "./style.sass"
export const Dedicated = () => {
  const history = useHistory()
  return (
    <div className="dedicated">
      <Container>
        <div className="dedicated__left">
          <h1>Crypto Banking. Dedicaded IBANS</h1>
          <p>
            Individual IBAN Accounts for Personal and Business Use. Experience seamless global transactions with virtual IBANs tailored to
            your personal needs or business operations.
          </p>
          <Button onClick={() => history.push("/register/corporate")} rightIcon={<ChevronRight />}>
            GET IBAN
          </Button>
        </div>
        <div className="dedicated__right">
          <Image src="/dedicated_phone.png" width={288} />
        </div>
      </Container>
    </div>
  )
}
